import React, {Component} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {Alert, Button, Card, CardBody, Input, InputGroup, InputGroupAddon, Table} from 'reactstrap';
import {FaListAlt, FaSearch} from "react-icons/fa";
import Breadcrumb from '../../Layout/Breadcrumb';
import { Spinner } from 'react-bootstrap';
import PaginateComponent from "../../PaginateComponent";
import ListLogByUserComponent from "../logs/ListLogByUserComponent";

class AdminLogActivityByUserComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            btnSubmit: false,
            listLogActivity: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            userId: 0,
            typeOrder: '',
            qtt: 30,
            service: '',
            type: '',
            listAction: []
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getUserDetail(this.props.userId);
    }

    getUserDetail = (userId) => {
        this.setState({
            isLoading: true
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = "?qtt=" + this.state.qtt + "&service=" + this.state.service + '&type=' + this.state.type;
        // console.log(data)
        axios.get(process.env.REACT_APP_API_URL + '/api/admin/log/listLogActivityByUser/' + userId + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        listLogActivity: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        listAction: ref.data.action,
                        loadPage: false,
                        isLoading: false
                    })
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000  ) {
                        this.redirect(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                    loadPage: false,
                    isLoading: false
                })
            })
    }

    screentListPayment = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            // console.log(this.state.listPayment.length)
            if ( this.state.listLogActivity.length ) {
                return (
                    this.state.listLogActivity.map( (log, key) => {
                        return (
                            <ListLogByUserComponent
                                key={key}
                                log={log}
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có đơn hàng trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    changeQtt = async (event) => {
        let value = event.target.value;
        await this.setState({
            qtt: value
        })
        await this.getUserDetail( this.props.userId );
    }

    changeAction = async (event) => {
        let value = event.target.value;
        await this.setState({
            type: value
        })
        await this.getUserDetail( this.props.userId );
    }

    search = (event) => {
        // console.log(event.target.value)
        this.setState({
            service: event.target.value
        })
    }

    submitSearch = (event) => {
        if(event.key === 'Enter') {
            this.getUserDetail(this.props.userId);
        }
    }

    btnSearch = () => {
        this.getUserDetail(this.props.userId);
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        let data = "?qtt=" + this.state.qtt + "&service=" + this.state.service + '&type=' + this.state.type + "&page=" + page;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/log/listLogActivityByUser/' + this.props.userId + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listLogActivity: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        isLoading: false
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000  ) {
                        this.redirect(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                })
            })
    }

    redirect = (message) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.shouldRedirect();
    }

    redirectBack = (message) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.redirectBack();
    }


    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Lịch sử hoạt động"} page={"Khách hàng"}
                                        icon={<FaListAlt className="breadcrumb-icon"/>}/>
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        { this.state.messageError }
                                    </Alert>
                                ) : (
                                    <Card>
                                        <CardBody>
                                            {
                                                this.state.error ? (
                                                    <Alert color="danger">
                                                        {this.state.messageError}
                                                    </Alert>
                                                ) : (
                                                    <div className="dataTables_wrapper dt-bootstrap">
                                                        <div className="list-group-email row">
                                                            <div className="col-md-4 mb-3 form-inline">
                                                                <select className="form-control form-control-sm mr-1" value={this.state.qtt} onChange={ this.changeQtt }>
                                                                    <option value="10">10</option>
                                                                    <option value="20">20</option>
                                                                    <option value="30">30</option>
                                                                    <option value="50">50</option>
                                                                    <option value="100">100</option>
                                                                    <option value="200">200</option>
                                                                </select>
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                <select className="form-control" value={this.state.type} onChange={ this.changeAction }>
                                                                    <option value="">Chọn trạng thái</option>
                                                                    {
                                                                        this.state.listAction.map( (action, key) => (
                                                                            <option value={ action.key } key={key}>{ action.value }</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <InputGroup>
                                                                    <Input placeholder="Tìm kiếm dịch vụ" onChange={ this.search } onKeyPress={ this.submitSearch } />
                                                                    <InputGroupAddon addonType="prepend">
                                                                        <Button onClick={ () => this.btnSearch() }> <FaSearch /> </Button>
                                                                    </InputGroupAddon>
                                                                </InputGroup>
                                                            </div>
                                                            <div className="col col-md-12 table-responsive">
                                                                <Table className="table table-sm table-bordered table-hover rounded table-list">
                                                                    <thead className={"primary"}>
                                                                        <tr>
                                                                            <th>Thời gian</th>
                                                                            <th>Hành động</th>
                                                                            <th>Dịch vụ</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        { this.screentListPayment() }
                                                                    </tbody>
                                                                </Table>
                                                                { this.paginate() }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </CardBody>
                                    </Card>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({type : 'logOut'}))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminLogActivityByUserComponent);